import "./navbar.css";
import { useLocation, useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faFishFins } from "@fortawesome/free-solid-svg-icons";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isOnHome = location?.pathname === "/";
  const isOnSelectProblem = location?.pathname === "/select-problem";

  const goHome = () => {
    if (isOnHome) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    navigate("/");
    window.scrollTo({ top: 0, behavior: "auto" });
  };

  return (
    <header className="navbar" aria-label="Site navigation">
      <button
        className="navbar__brand"
        type="button"
        onClick={goHome}
      >
        <span className="navbar__mark" aria-hidden="true">
          <FontAwesomeIcon icon={faFishFins} />
        </span>
        <span className="navbar__text">Blåhaj</span>
      </button>

      <nav className="navbar__nav" aria-label="Primary">
        <button
          className="navbar__link navbar__link--button"
          type="button"
          aria-current={isOnHome ? "page" : undefined}
          onClick={goHome}
        >
          Home
        </button>
        <button
          className="navbar__link navbar__link--button"
          type="button"
          aria-current={isOnSelectProblem ? "page" : undefined}
          onClick={() => navigate("/select-problem")}
        >
          Problems
        </button>
        <a className="navbar__link" href="https://github.com/ace-n/blahaj-app" target="_blank" rel="noreferrer">
          GitHub
          <FontAwesomeIcon className="navbar__externalIcon" icon={faArrowUpRightFromSquare} />
        </a>
      </nav>
    </header>
  );
}


